import Layers from "slotworks/graphics/layers/layers";
import ButtonElement, { ButtonEvent } from "slotworks/graphics/elements/button-element";
import BonusBuyContainer from "./bonus-buy-container";
import { DisableUIButtons, EnableUIButtons } from "commands/ui-buttons";
import deviceInfo from "slotworks/utils/device-info";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import settingsModel from "slotworks/model/settings/settings-model";
import Components from "slotworks/components/components";

export default class BonusBuyButtonComponent {

    private layer: Layers;
    private buyButton: ButtonElement;

    private started: boolean = false;
    private enabled: boolean = false;
    private hidden: boolean = false;

    private bonusBuyContainer: BonusBuyContainer;

    public start() {
        this.started = true;

        this.layer = Layers.Custom.get("BonusBuy");
        this.layer.show();
        this.layer.setScene("bonusbuy").execute();

        this.bonusBuyContainer = new BonusBuyContainer();

        this.setButton();

        this.setEnabled(true);

        Layers.BetBarPopups.onSceneEnter.add((scene: string) => {
            if(scene == "default") {
                this.setEnabled(this.enabled);
            } else {
                if (this.buyButton) {
                    this.buyButton.setEnabled(false);
                }
            }
        });

        if(!deviceInfo.isDesktop) {
            const resetPosition = () => {
                if(canvasManager.orientation == Orientation.LANDSCAPE) {
                    const isLeft = settingsModel.getLeftHanded();
                    const position = this.layer.getPosition(isLeft ? "buy-left" : "buy");
                    this.buyButton.setPosition(position.x, position.y);
                }
            }
            Components.betMenu.onSettingsOptionsCommitted.add(() => {
                setTimeout(resetPosition, 10);
            });

            deviceInfo.onLayoutChange.add(() => {
                setTimeout(() => {
                    this.setButton();
                    resetPosition();
                }, 10);
            });

            resetPosition();
        }
    }

    public setEnabled(enable: boolean) {
        this.enabled = enable;

        if (this.buyButton) {
            this.buyButton.setEnabled(this.enabled);
        }
    }

    public show(instant:boolean = false) {
        if(this.started) {
            this.hidden = false;
            // this.buyButton.setVisible(true);
            this.layer.show();
        }
    }

    public hide(instant: boolean = false) {
        if(this.started && !this.hidden) {
            this.hidden = true;
            // this.buyButton.setVisible(false);
            this.layer.hide();
        }
    }

    private setButton() {
        if (this.buyButton) {
            this.buyButton.off(ButtonEvent.POINTER_DOWN, this.showBuyPrompt);
            this.buyButton = null;
        }

        this.buyButton = this.layer.getButton("buy");
        this.buyButton.on(ButtonEvent.POINTER_DOWN, this.showBuyPrompt);

        const feature = this.layer.getText("feature_text");
        if(feature) {
            this.buyButton.container.addChild(feature);
            feature.x -= this.buyButton.container.x;
            feature.y -= this.buyButton.container.y;
        }
        const buyText = this.layer.getText("buy_text");
        if(buyText) {
            this.buyButton.container.addChild(buyText);
            buyText.x -= this.buyButton.container.x;
            buyText.y -= this.buyButton.container.y;
        }

        this.buyButton.setEnabled(this.enabled);
    }

    private showBuyPrompt = () => {
        if(this.started && this.enabled) {
            DisableUIButtons();
            this.bonusBuyContainer.show().then((res) => {
                if(!res) {
                    EnableUIButtons();
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/bonus-buy/bonus-buy-button-component.ts